import React from "react";
import clsx from "clsx";
import NumberSpinner from "../../NumberSpinner/NumberSpinner";
import I18n from "i18n-js";
import Switch from "../../Switch/Switch";

export default class PropertyDetailsBuilderPricing extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    var tabClasses = clsx({
      active: this.props.active_tab == "pricing",
      "tab-pane": true,
    });
    return (
      <div className={tabClasses}>
        <div className="row" style={{marginBottom: '-15px'}}>
          <div className="col-md-3">
            <div className="form-group">
              <label>{I18n.t('pricing_table_enabled')}</label>
              <Switch 
                onText="enabled" 
                offText="disabled" 
                name="pricing_table_enabled"
                onChange={this.props.onFlipSwitch}
                value={this.props.pricing_table_enabled} 
                switchId="pricing_table_enabled"
              />
            </div>
          </div>
          <div className="col-md-3">
            <div className="form-group">
              <label>{I18n.t('pricing_table_size')}</label>
              <NumberSpinner 
                name="pricing_table_size"
                max={365}
                value={this.props.pricing_table_size}
                onChange={(e) => { this.props.onChange(e) }}
              />
            </div>
          </div>
        </div>


      </div>
    )
  }

  onChangeSwitch(name, e) {
    console.log("onChangeSwitch", name, e);
    
    this.props.onFlipSwitch(name, e.target.checked);
  }

}
